import Link from 'next/link';
import { createComponent, IntrinsicProps } from 'react-commons';
import { ArticleData } from '@/lib/drupal/models/Articles';

import style from './index.module.scss';

interface DailyAppHeaderProps extends IntrinsicProps {
  taxonomyDescription?: ArticleData | null;
}

export const HEADER_HEIGHT = 48;

export default createComponent<DailyAppHeaderProps>('DailyAppHeader', { style }, function DailyAppHeader ({ className }, props) {
  return (
    <header className={className} style={{ height: HEADER_HEIGHT }}>
      <div className='DailyAppHeader__Inner'>
        <div style={{ height: '34px' }}>
          <img
            src='/images/SW_Stamp_White.svg' 
            alt='Shockwave.com'
            width='44'
            height='57'
            style={{ width: 'auto', height: '34px' }}
            className='DailyAppHeader__MobileLogo'
          />
          <img
            src='/images/SW25_alt.svg' 
            alt='Shockwave.com'
            width='34'
            height='92'
            style={{ width: 'auto', height: '34px' }}
            className='DailyAppHeader__DesktopLogo'
          />
        </div>
      </div>
    </header>
  );
});
